import { gql } from '@apollo/client';

export default gql`
  mutation updatePageData($name: String, $cache: JSON!, $itemId: String) {
    updatePageData(name: $name, cache: $cache) {
      cache {
        ... on Homepage {
          headerPosition
          navTextColor
          banner {
            image
            position
            text
            backgroundColor
            enable
            withImage
            opacity
            textDecoration
            textDecorationColor
            imageBlendMode
          }
          newsFeed {
            title
            feed
            enabled
            position
            backgroundColor
          }
          columns
          introContent {
            text
            backgroundColor
            type
          }
          subContent {
            text
            backgroundColor
          }
          showProgress
          mainContentBackgroundColor
          children {
            enable
            thumbnail {
              image
              position
            }
            planNodeId
            title
            description
            progress
            onTrack
            upcoming
            statusPending
            minorDisruption
            majorDisruption
            completed
            discontinued
            tags
          }
          overlapCardTitle
          showCardDescription
        }
        ... on PlanNodePage {
          title
          description
          latestUpdate
          additionalText
          additionalBottomText
          additionalMiddleText
          additionalUpperMiddleText
          showLatestUpdate
          planNodeId
          progress
          onTrack
          upcoming
          statusPending
          minorDisruption
          majorDisruption
          completed
          discontinued
          numberWithLabel
          startDate
          endDate
          budget
          expenditure
          phase
          children {
            cloneSourcePlanNodeId
            completed
            description
            discontinued
            enable
            budget
            expenditure
            phase
            majorDisruption
            minorDisruption
            onTrack
            planNodeId
            progress
            rollup
            statusPending
            tags
            title
            upcoming
          }
          measures {
            embed
            enable
            title
            comment
            measureId
            viewType
            advancedMetric
            advancedMetricType
            advancedMetricTargetUnit
            advancedMetricChartType
            singleTargetMilestoneDate
            singleTargetTargetAmount
            singleTargetAggregationFunction
            handsontable
            highChartSetting
            performanceGraphUrl
            metricType
            summaryDetails
            label
            visualTitle
            visualDescription
            tags
          }
          tags
          customFieldRecords {
            checkBoxChecked
            content
            customFieldId
            id
            picklistItems
          }
        }
        ... on MeasurePage {
          embed
          title
          description
          showComment
          comment
          additionalText
          additionalBottomText
          additionalMiddleText
          additionalUpperMiddleText
          measureId
          viewType
          advancedMetric
          advancedMetricType
          advancedMetricTargetUnit
          advancedMetricChartType
          singleTargetMilestoneDate
          singleTargetTargetAmount
          singleTargetAggregationFunction
          handsontable
          highChartSetting
          performanceGraphUrl
          metricType
          summaryDetails
          label
          visualTitle
          visualDescription
          tags
        }
      }
      affectedList {
        id
        title
        description
        enable
      }
    }
    itemId(itemId: $itemId)
  }
`; 